import React, { useEffect, useRef, useState } from "react";
import "../Style.css";
import "../Responsive.css";
import "../bootstrap.min.css";
import {
  TextField,
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  Card,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connectToStore } from "../data/store";
import { CampaignContentType, SideBarMenuNames, UserRoles } from "../core/Constants";
import SideBarMenuItems from "./SideBarMenuItems";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

// Images
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";

// Menu
import SearchIcon from "@mui/icons-material/Search";

import { AddNewCampaignPage } from "../core/PageConstants";
import { display } from "@mui/system";
import { postAsync } from "../core/serviceClient";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import Utils from "../core/Utils";
import ConfirmPopup from "./common/ConfirmPopup";
import RefreshIcon from "@mui/icons-material/Refresh";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Campaigns = (props) => {
  document.title = "Campaigns";
  const navigate = useNavigate();
  const location = useLocation();
  const orderStatuses = ["Draft", "Active", "Approved", "Ended"];

  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [searchText, setSearchText] = useState("");
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [campaignList, setCampainList] = useState([]);
  const [filterCampaignList, setFilterCampaignList] = useState([]);
  const [draftCampaignList, setDraftCampaignList] = useState([]);
  const [filterDraftCampaignList, setFilterDraftCampaignList] = useState([]);
  const [approvedCampaignList, setApprovedCampaignList] = useState([]);
  const [filterApprovedCampaignList, setFilterApprovedCampaignList] = useState([]);
  const [activeCampaignList, setActiveCampaignList] = useState([]);
  const [filterActiveCampaignList, setFilterActiveCampaignList] = useState([]);
  const [endedCampaignList, setEndedCampaignList] = useState([]);
  const [filterEndedCampaignList, setFilterEndedCampaignList] = useState([]);
  const [userRole, setUserRole] = useState(UserRoles.Technician);
  const [isOpenedEndCampaign, setIsOpenedEndCampaign] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState({});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  const inputRef = useRef(null);

  useEffect(() => {
    getAllCampaigns();
    if (!Utils.IsNullOrEmptyObject(localSettings) && !Utils.IsNullOrEmptyObject(localSettings.user)) {
      setUserRole(localSettings?.user?.role);
    }
  }, [localSettings]);

  const handleSubmit = (e) => {
    if (isLoading) return
    e.preventDefault();
    searchCampaings();
  };

  const handleSearch = (campaignList) => {
    const filtered = campaignList.filter((campaign) =>
      campaign.name.toLowerCase().includes(searchText.toLowerCase())
    );
    return filtered;
  };

  const searchCampaings = () => {
    if (isLoading) return

    if (!Utils.IsNullOrEmpty(searchText)) {
      let filtered1 = handleSearch(campaignList);
      setFilterCampaignList(filtered1);
      let filtered2 = handleSearch(activeCampaignList);
      setFilterActiveCampaignList(filtered2);
      let filtered3 = handleSearch(approvedCampaignList);
      setFilterApprovedCampaignList(filtered3);
      let filtered4 = handleSearch(draftCampaignList);
      setFilterDraftCampaignList(filtered4);
      let filtered5 = handleSearch(endedCampaignList);
      setFilterEndedCampaignList(filtered5);
      let filtered6 = handleSearch(campaignList);
      setFilterCampaignList(filtered6);
    } else {
      setFilterCampaignList(campaignList);
      setFilterActiveCampaignList(activeCampaignList);
      setFilterApprovedCampaignList(approvedCampaignList);
      setFilterDraftCampaignList(draftCampaignList);
      setFilterEndedCampaignList(endedCampaignList);
      setFilterCampaignList(campaignList);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getAllCampaigns = async () => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let result1 = await postAsync(
        "Campaign/GetCampaign",
        {},
        "",
        "GetAll",
        "AllCampaignsForBusiness",
        [localSettings.business.id, localSettings.branch.branchId]
      );
      if (result1.error) {
        setMsgOpen(true);
        setMsgText(result1.errorMessage);
      } else {
        if (!Utils.IsNullOrEmptyArray(result1.data)) {
          let reverseData = result1.data.reverse();
          const sortedCampaignList = reverseData.sort(
            (a, b) => orderStatuses.indexOf(a.status) - orderStatuses.indexOf(b.status)
          );
          const approvedCampaignList = reverseData.filter((d) => d.status === "Approved");
          const draftCampaignList = reverseData.filter((d) => d.status === "Draft");
          const activeCampaignList = reverseData.filter((d) => d.status === "Active");
          const endedCampaignList = reverseData.filter((d) => d.status === "Ended");
          setCampainList(sortedCampaignList);
          setFilterCampaignList(sortedCampaignList);
          setApprovedCampaignList(approvedCampaignList);
          setFilterApprovedCampaignList(approvedCampaignList);
          setDraftCampaignList(draftCampaignList);
          setFilterDraftCampaignList(draftCampaignList);
          setActiveCampaignList(activeCampaignList);
          setFilterActiveCampaignList(activeCampaignList);
          setEndedCampaignList(endedCampaignList);
          setFilterEndedCampaignList(endedCampaignList);
        }
      }

      setIsLoading(false);
    }
  };

  const handleMsgClose = () => {
    setMsgOpen(false);
  };

  const handleConfirmClose = (value) => {
    if (isLoading) return
    setConfirmOpen(false);
    setIsOpenedEndCampaign(false);
    if (value === "OK" && isOpenedEndCampaign) {
      handleCloseCampaign()
    }
  }

  const handleEditCampaign = (e, campaign) => {
    if (isLoading) return
    e.preventDefault();
    e.stopPropagation();
    navigate(AddNewCampaignPage.Path, {
      state: {
        ...location.state,
        isEdit: true,
        isFromCampaignList: true,
        campaign: campaign,
      },
    });
  };

  const handleDeleteCampaign = (e, campaign) => {
    if (isLoading) return
    e.preventDefault();
    e.stopPropagation();
    navigate(AddNewCampaignPage.Path, {
      state: {
        ...location.state,
        isDelete: true,
        isFromCampaignList: true,
        campaign: campaign,
      },
    });
  };

  const handleApproveCampaign = (e, campaign) => {
    if (isLoading) return
    e.preventDefault();
    e.stopPropagation();
    navigate(AddNewCampaignPage.Path, {
      state: {
        ...location.state,
        isApprove: true,
        isFromCampaignList: true,
        campaign: campaign,
      },
    });
  };

  const handleEndCampaign = (e, campaign) => {
    if (isLoading) return
    e.preventDefault();
    e.stopPropagation();
    setSelectedCampaign(campaign);
    setConfirmOpen(true);
    setConfirmText("Are you sure you want to end campaign");
    setIsOpenedEndCampaign(true);
  }

  const handleCloseCampaign = async () => {
    if (isLoading) return
    setIsOpenedEndCampaign(false);
    if (!Utils.IsNullOrEmptyObject(selectedCampaign)) {
      setIsLoading(true);
      let result = await postAsync(
        "Campaign/EndCampaign", {
        BusinessId: localSettings.business.businessId,
        BranchId: localSettings.branch.branchId,
        CampaignId: selectedCampaign.id,
      }
      )
      setIsLoading(false);
      if (result && result.error) {
        setMsgOpen(true);
        setMsgText(result.errorMessage);
      } else if (result && result.data) {
        setMsgOpen(true);
        setMsgText("Successfully ended the campaign");
        getAllCampaigns();
      }
    }
  }

  const handleReadOnlyCampaign = (e, campaign) => {
    if (isLoading) return
    navigate(AddNewCampaignPage.Path, {
      state: {
        ...location.state,
        isReadOnlyCampaign: true,
        isFromCampaignList: true,
        campaign: campaign,
      },
    });
  }

  const refreshCampaigns = () => {
    getAllCampaigns();
  }

  return (
    <Container maxWidth="false" className="bg-color p-0 setting-page">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <ConfirmPopup
          confirmOpen={confirmOpen}
          confirmText={confirmText}
          onConfirmClose={handleConfirmClose}
        />
        <Grid container m={0}>
          <SideBarMenuItems selectedTab={SideBarMenuNames.Campaigns} />
          <Grid
            xs={12}
            className="content-sec"
            style={{ "padding-bottom": "140px" }}
          >
            <Grid container direction="row" className="">
              <Grid flex="1" spacing={2}>
                <Grid container className="title-sec">
                  <Stack direction="row" spacing={4}>
                    <Typography
                      level="h2"
                      component="h2"
                      fontWeight="600"
                      fontSize="2rem"
                      className="page-title text-center"
                    >
                      Campaigns - {campaignList.length}{" "}
                    </Typography>
                    <IconButton
                      variant="outline"
                      size="small"
                      className="mt-h"
                      fullWidth="true"
                      onClick={refreshCampaigns}
                      title="Refresh"
                      sx={{ alignSelf: "center" }}
                    >
                      <RefreshIcon sx={{ fontSize: "24px" }} />
                    </IconButton>
                  </Stack>
                  <form
                    method="post"
                    className="search-form fixed-xs-btn"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                    alignSelf="center"
                  >
                    <Stack
                      direction="row"
                      alignSelf="center"
                      spacing={1}
                      style={{ width: "100%" }}
                      className="mr-1"
                    >
                      <Grid flex="1">
                        <TextField
                          className="form-control font-size-14"
                          placeholder="Search campaigns..."
                          value={searchText}
                          disabled={isLoading}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{ "min-width": "300px" }}
                          inputRef={inputRef}
                          InputProps={{
                            endAdornment: (
                              <>
                                {searchText && (
                                  <IconButton
                                    onClick={() => {
                                      setSearchText("");
                                      setTimeout(() => inputRef.current?.focus(), 0);
                                    }}
                                    edge="end"
                                    size="small"
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                )}
                              </>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          className="submitBtn btn-secondary h-100"
                          fullWidth="true"
                          disabled={isLoading}
                        >
                          <SearchIcon sx={{ fontSize: 24 }} />
                          <span className="btn-text">Search</span>
                        </Button>
                      </Grid>
                    </Stack>
                    <Stack alignSelf="center">
                      <Link
                        to={AddNewCampaignPage.Path}
                        className="btn btn-primary float-btn"
                        variant="contained"
                        style={{ display: "flex", height: "46px" }}
                        disabled={isLoading}
                      >
                        <LibraryAddOutlinedIcon
                          fontSize="large"
                          alignSelf="center"
                        />
                        <span className="hidden-xs ml-h">Create</span>
                      </Link>
                    </Stack>
                  </form>
                </Grid>

                <Grid container direction="row">
                  <Box sx={{ width: "100%" }}>
                    <Box
                      sx={{ borderBottom: 1, borderColor: "divider" }}
                      className="font-size-14"
                    >
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="campaigns tabs"
                      >
                        <Tab label={`All-${campaignList.length}`} {...a11yProps(0)} />
                        <Tab label={`Active-${activeCampaignList.length}`} {...a11yProps(1)} />
                        <Tab label={`Approved-${approvedCampaignList.length}`} {...a11yProps(2)} />
                        <Tab label={`Draft-${draftCampaignList.length}`} {...a11yProps(3)} />
                        <Tab label={`Ended-${endedCampaignList.length}`} {...a11yProps(4)} />
                      </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                      <Box sx={{ flexGrow: 1 }} py={3}>
                        <Grid container xs={12} spacing={2}>
                          {!Utils.IsNullOrEmptyArray(filterCampaignList) &&
                            filterCampaignList.map((campaign) => (
                              <Grid item xs={12} sm={4} md={4}>
                                <Card onClick={(e) => handleReadOnlyCampaign(e, campaign)} sx={{ boxShadow: "none", cursor: "pointer", border: "1px solid #e3e3e3" }}>
                                  <Stack
                                    className="campaign-img"
                                    direction={campaign?.offerImage ? "row" : "column"}
                                    justifyContent={campaign?.offerImage ? "flex-start" : "center"}
                                    spacing={2}
                                    sx={{
                                      width: "100%",
                                      textAlign: "left",
                                      background: campaign?.creativeBGColor || "white"
                                    }}

                                  >
                                    {campaign?.offerImage && (
                                      <Box
                                        component="img"
                                        src={campaign.offerImage}
                                        sx={{
                                          width: campaign?.contentType !== CampaignContentType.BannerImage ? "60%" : "100%",
                                          // backgroundImage: `url(${campaign.offerImage})`,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      />
                                    )}
                                    {campaign?.contentType !== CampaignContentType.BannerImage && <Box alignSelf="center"


                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "blue" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine1 || ""}
                                      </Typography>
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine2 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "green" : "#e8d52a",
                                        }}
                                      >
                                        {campaign?.creativeLine3 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine4 || ""}
                                      </Typography>}
                                    </Box>}
                                  </Stack>
                                  <Stack p={2}>
                                    <Stack
                                      justifyContent="space-between"
                                      flexDirection="row"
                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1.2rem"
                                        className="text-muted"
                                      >
                                        {`${Utils.ConvertToLocalDTOnly(
                                          campaign.start,
                                          localSettings.country
                                        )} - ${Utils.ConvertToLocalDTOnly(
                                          campaign.end,
                                          localSettings.country
                                        )}`}
                                      </Typography>
                                      <Chip
                                        label={campaign.status}
                                        color={
                                          campaign.status === "Approved"
                                            ? "primary" :
                                            campaign.status === "Active"
                                              ? "success" :
                                              campaign.status === "Ended"
                                                ? "error"
                                                : "warning"
                                        }
                                        alignSelf="end"
                                      />
                                    </Stack>
                                    <Typography
                                      component="h3"
                                      fontSize="2rem"
                                      fontWeight="600"
                                    >
                                      {campaign.name}
                                    </Typography>
                                  </Stack>
                                  <Grid
                                    container
                                    className="text-center"
                                    p={2}
                                    sx={{
                                      borderTop: 1,
                                      borderColor: "divider",
                                    }}
                                  >
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.invited}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Invited
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.participants}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Participants
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.revenue).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Revenue
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.profit).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Profit
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  {(userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && campaign.status !== "Approved" && campaign.status !== "Active" && campaign.status !== "Ended" && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEditCampaign(e, campaign)
                                        }
                                      >
                                        <span>Edit</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleDeleteCampaign(e, campaign)
                                        }
                                      >
                                        <span>Delete</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleApproveCampaign(e, campaign)
                                        }
                                      >
                                        <span>Approve</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                  {campaign.status === "Active" && (userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEndCampaign(e, campaign)
                                        }
                                      >
                                        <span>End</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                </Card>
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                      <Box sx={{ flexGrow: 1 }} py={3}>
                        <Grid container xs={12} spacing={2}>
                          {!Utils.IsNullOrEmptyArray(filterActiveCampaignList) &&
                            filterActiveCampaignList.map((campaign) => (
                              <Grid item xs={12} sm={4} md={4}>
                                <Card onClick={(e) => handleReadOnlyCampaign(e, campaign)} sx={{ boxShadow: "none", cursor: "pointer" }}>
                                  <Stack
                                    className="campaign-img"
                                    direction={campaign?.offerImage ? "row" : "column"}
                                    justifyContent={campaign?.offerImage ? "flex-start" : "center"}
                                    spacing={2}
                                    sx={{
                                      width: "100%",
                                      textAlign: "left",
                                      background: campaign?.creativeBGColor || "white"
                                    }}
                                  >
                                    {campaign?.offerImage && (
                                      <Box
                                        sx={{
                                          width: campaign?.contentType !== CampaignContentType.BannerImage ? "60%" : "100%",
                                          backgroundImage: `url(${campaign.offerImage})`,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      />
                                    )}
                                    {campaign?.contentType !== CampaignContentType.BannerImage && <Box alignSelf="center"

                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "blue" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine1 || ""}
                                      </Typography>
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine2 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "green" : "#e8d52a",
                                        }}
                                      >
                                        {campaign?.creativeLine3 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine4 || ""}
                                      </Typography>}
                                    </Box>}
                                  </Stack>
                                  <Stack p={2}>
                                    <Stack
                                      justifyContent="space-between"
                                      flexDirection="row"
                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1.2rem"
                                        className="text-muted"
                                      >
                                        {`${Utils.ConvertToLocalDTOnly(
                                          campaign.start,
                                          localSettings.country
                                        )} - ${Utils.ConvertToLocalDTOnly(
                                          campaign.end,
                                          localSettings.country
                                        )}`}
                                      </Typography>
                                      <Chip
                                        label={campaign.status}
                                        color={
                                          campaign.status === "Approved"
                                            ? "primary" :
                                            campaign.status === "Active"
                                              ? "success" :
                                              campaign.status === "Ended"
                                                ? "error"
                                                : "warning"
                                        }
                                        alignSelf="end"
                                      />
                                    </Stack>
                                    <Typography
                                      component="h3"
                                      fontSize="2rem"
                                      fontWeight="600"
                                    >
                                      {campaign.name}
                                    </Typography>
                                  </Stack>
                                  <Grid
                                    container
                                    className="text-center"
                                    p={2}
                                    sx={{
                                      borderTop: 1,
                                      borderColor: "divider",
                                    }}
                                  >
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.invited}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Invited
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.participants}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Participants
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.revenue).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Revenue
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.profit).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Profit
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  {(userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && campaign.status !== "Approved" && campaign.status !== "Active" && campaign.status !== "Ended" && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEditCampaign(e, campaign)
                                        }
                                      >
                                        <span>Edit</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleDeleteCampaign(e, campaign)
                                        }
                                      >
                                        <span>Delete</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleApproveCampaign(e, campaign)
                                        }
                                      >
                                        <span>Approve</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                  {campaign.status === "Active" && (userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEndCampaign(e, campaign)
                                        }
                                      >
                                        <span>End</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                </Card>
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                      <Box sx={{ flexGrow: 1 }} py={3}>
                        <Grid container xs={12} spacing={2}>
                          {!Utils.IsNullOrEmptyArray(filterApprovedCampaignList) &&
                            filterApprovedCampaignList.map((campaign) => (
                              <Grid item xs={12} sm={4} md={4}>
                                <Card onClick={(e) => handleReadOnlyCampaign(e, campaign)} sx={{ boxShadow: "none", cursor: "pointer" }}>
                                  <Stack
                                    className="campaign-img"
                                    direction={campaign?.offerImage ? "row" : "column"}
                                    justifyContent={campaign?.offerImage ? "flex-start" : "center"}
                                    spacing={2}
                                    sx={{
                                      width: "100%",
                                      textAlign: "left",
                                      background: campaign?.creativeBGColor || "white"
                                    }}
                                  >
                                    {campaign?.offerImage && (
                                      <Box
                                        sx={{
                                          width: campaign?.contentType !== CampaignContentType.BannerImage ? "60%" : "100%",
                                          backgroundImage: `url(${campaign.offerImage})`,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      />
                                    )}
                                    {campaign?.contentType !== CampaignContentType.BannerImage && <Box alignSelf="center"

                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "blue" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine1 || ""}
                                      </Typography>
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine2 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "green" : "#e8d52a",
                                        }}
                                      >
                                        {campaign?.creativeLine3 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine4 || ""}
                                      </Typography>}
                                    </Box>}
                                  </Stack>
                                  <Stack p={2}>
                                    <Stack
                                      justifyContent="space-between"
                                      flexDirection="row"
                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1.2rem"
                                        className="text-muted"
                                      >
                                        {`${Utils.ConvertToLocalDTOnly(
                                          campaign.start,
                                          localSettings.country
                                        )} - ${Utils.ConvertToLocalDTOnly(
                                          campaign.end,
                                          localSettings.country
                                        )}`}
                                      </Typography>
                                      <Chip
                                        label={campaign.status}
                                        color={
                                          campaign.status === "Approved"
                                            ? "primary" :
                                            campaign.status === "Active"
                                              ? "success" :
                                              campaign.status === "Ended"
                                                ? "error"
                                                : "warning"
                                        }
                                        alignSelf="end"
                                      />
                                    </Stack>
                                    <Typography
                                      component="h3"
                                      fontSize="2rem"
                                      fontWeight="600"
                                    >
                                      {campaign.name}
                                    </Typography>
                                  </Stack>
                                  <Grid
                                    container
                                    className="text-center"
                                    p={2}
                                    sx={{
                                      borderTop: 1,
                                      borderColor: "divider",
                                    }}
                                  >
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.invited}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Invited
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.participants}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Participants
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.revenue).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Revenue
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.profit).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Profit
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  {(userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && campaign.status !== "Approved" && campaign.status !== "Active" && campaign.status !== "Ended" && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEditCampaign(e, campaign)
                                        }
                                      >
                                        <span>Edit</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleDeleteCampaign(e, campaign)
                                        }
                                      >
                                        <span>Delete</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleApproveCampaign(e, campaign)
                                        }
                                      >
                                        <span>Approve</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                  {campaign.status === "Active" && (userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEndCampaign(e, campaign)
                                        }
                                      >
                                        <span>End</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                </Card>
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                      <Box sx={{ flexGrow: 1 }} py={3}>
                        <Grid container xs={12} spacing={2}>
                          {!Utils.IsNullOrEmptyArray(filterDraftCampaignList) &&
                            filterDraftCampaignList.map((campaign) => (
                              <Grid item xs={12} sm={4} md={4}>
                                <Card onClick={(e) => handleReadOnlyCampaign(e, campaign)} sx={{ boxShadow: "none", cursor: "pointer" }}>
                                  <Stack
                                    className="campaign-img"
                                    direction={campaign?.offerImage ? "row" : "column"}
                                    justifyContent={campaign?.offerImage ? "flex-start" : "center"}
                                    spacing={2}
                                    sx={{
                                      width: "100%",
                                      textAlign: "left",
                                      background: campaign?.creativeBGColor || "white"
                                    }}
                                  >
                                    {campaign?.offerImage && (
                                      <Box
                                        sx={{
                                          width: campaign?.contentType !== CampaignContentType.BannerImage ? "60%" : "100%",
                                          backgroundImage: `url(${campaign.offerImage})`,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      />
                                    )}
                                    {campaign?.contentType !== CampaignContentType.BannerImage && <Box alignSelf="center">
                                      <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "blue" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine1 || ""}
                                      </Typography>
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine2 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "green" : "#e8d52a",
                                        }}
                                      >
                                        {campaign?.creativeLine3 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine4 || ""}
                                      </Typography>}
                                    </Box>}
                                  </Stack>
                                  <Stack p={2}>
                                    <Stack
                                      justifyContent="space-between"
                                      flexDirection="row"
                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1.2rem"
                                        className="text-muted"
                                      >
                                        {`${Utils.ConvertToLocalDTOnly(
                                          campaign.start,
                                          localSettings.country
                                        )} - ${Utils.ConvertToLocalDTOnly(
                                          campaign.end,
                                          localSettings.country
                                        )}`}
                                      </Typography>
                                      <Chip
                                        label={campaign.status}
                                        color={
                                          campaign.status === "Approved"
                                            ? "primary" :
                                            campaign.status === "Active"
                                              ? "success" :
                                              campaign.status === "Ended"
                                                ? "error"
                                                : "warning"
                                        }
                                        alignSelf="end"
                                      />
                                    </Stack>
                                    <Typography
                                      component="h3"
                                      fontSize="2rem"
                                      fontWeight="600"
                                    >
                                      {campaign.name}
                                    </Typography>
                                  </Stack>
                                  <Grid
                                    container
                                    className="text-center"
                                    p={2}
                                    sx={{
                                      borderTop: 1,
                                      borderColor: "divider",
                                    }}
                                  >
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.invited}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Invited
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.participants}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Participants
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.revenue).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Revenue
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.profit).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Profit
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  {(userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && campaign.status !== "Approved" && campaign.status !== "Active" && campaign.status !== "Ended" && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEditCampaign(e, campaign)
                                        }
                                      >
                                        <span>Edit</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleDeleteCampaign(e, campaign)
                                        }
                                      >
                                        <span>Delete</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleApproveCampaign(e, campaign)
                                        }
                                      >
                                        <span>Approve</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                  {campaign.status === "Active" && (userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEndCampaign(e, campaign)
                                        }
                                      >
                                        <span>End</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                </Card>
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={4}>
                      <Box sx={{ flexGrow: 1 }} py={3}>
                        <Grid container xs={12} spacing={2}>
                          {!Utils.IsNullOrEmptyArray(filterEndedCampaignList) &&
                            filterEndedCampaignList.map((campaign, index) => (
                              <Grid item xs={12} sm={4} md={4}>
                                <Card onClick={(e) => handleReadOnlyCampaign(e, campaign)} sx={{ boxShadow: "none", cursor: "pointer" }}>
                                  <Stack
                                    className="campaign-img"
                                    direction={campaign?.offerImage ? "row" : "column"}
                                    justifyContent={campaign?.offerImage ? "flex-start" : "center"}
                                    spacing={2}
                                    sx={{
                                      width: "100%",
                                      textAlign: "left",
                                      background: campaign?.creativeBGColor || "white"
                                    }}
                                  >
                                    {campaign?.offerImage && (
                                      <Box
                                        sx={{
                                          width: campaign?.contentType !== CampaignContentType.BannerImage ? "60%" : "100%",
                                          backgroundImage: `url(${campaign.offerImage})`,
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      />
                                    )}
                                    {campaign?.contentType !== CampaignContentType.BannerImage && <Box alignSelf="center">
                                      <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "blue" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine1 || ""}
                                      </Typography>
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine2 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "green" : "#e8d52a",
                                        }}
                                      >
                                        {campaign?.creativeLine3 || ""}
                                      </Typography>}
                                      {!campaign.creativeIsHtml && <Typography
                                        component="h4"
                                        fontSize="1rem"
                                        fontWeight="600"
                                        style={{
                                          color: campaign?.creativeBGColor === "White" ? "black" : "white",
                                        }}
                                      >
                                        {campaign?.creativeLine4 || ""}
                                      </Typography>}
                                    </Box>}
                                  </Stack>
                                  <Stack p={2}>
                                    <Stack
                                      justifyContent="space-between"
                                      flexDirection="row"
                                    >
                                      <Typography
                                        component="h4"
                                        fontSize="1.2rem"
                                        className="text-muted"
                                      >
                                        {`${Utils.ConvertToLocalDTOnly(
                                          campaign.start,
                                          localSettings.country
                                        )} - ${Utils.ConvertToLocalDTOnly(
                                          campaign.end,
                                          localSettings.country
                                        )}`}
                                      </Typography>
                                      <Chip
                                        label={campaign.status}
                                        color={
                                          campaign.status === "Approved"
                                            ? "primary" :
                                            campaign.status === "Active"
                                              ? "success" :
                                              campaign.status === "Ended"
                                                ? "error"
                                                : "warning"
                                        }
                                        alignSelf="end"
                                      />
                                    </Stack>
                                    <Typography
                                      component="h3"
                                      fontSize="2rem"
                                      fontWeight="600"
                                    >
                                      {campaign.name}
                                    </Typography>
                                  </Stack>
                                  <Grid
                                    container
                                    className="text-center"
                                    p={2}
                                    sx={{
                                      borderTop: 1,
                                      borderColor: "divider",
                                    }}
                                  >
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.invited}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Invited
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {campaign.participants}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Participants
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.revenue).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Revenue
                                      </Typography>
                                    </Grid>
                                    <Grid xs={12} sm={3} md={3}>
                                      <Typography
                                        component="h3"
                                        fontSize="1.8rem"
                                        fontWeight="600"
                                      >
                                        {Number(campaign.profit).toFixed(2)}
                                      </Typography>
                                      <Typography
                                        component="h4"
                                        fontSize="1.3rem"
                                        className="text-muted"
                                      >
                                        Profit
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  {(userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && campaign.status !== "Approved" && campaign.status !== "Active" && campaign.status !== "Ended" && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEditCampaign(e, campaign)
                                        }
                                      >
                                        <span>Edit</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleDeleteCampaign(e, campaign)
                                        }
                                      >
                                        <span>Delete</span>
                                      </li>
                                      <li
                                        onClick={(e) =>
                                          handleApproveCampaign(e, campaign)
                                        }
                                      >
                                        <span>Approve</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                  {campaign.status === "Active" && (userRole === UserRoles.GlobalAdmin || userRole === UserRoles.BranchAdmin) && <Grid className="menuList campaignmenuList">
                                    <ul>
                                      <li
                                        onClick={(e) =>
                                          handleEndCampaign(e, campaign)
                                        }
                                      >
                                        <span>End</span>
                                      </li>
                                    </ul>
                                  </Grid>}
                                </Card>
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    </CustomTabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Campaigns;
